import { SplideSlide } from '@splidejs/react-splide'
import castArray from 'lodash/castArray'
import filter from 'lodash/filter'
import map from 'lodash/map'
import React, { cloneElement, FC, memo, ReactElement, useMemo, useState } from 'react'

import { StaticUpsellWrapper, StyledContainerSlider } from '@Components/AddedToCartModal/styledElements'
import appTheme from '@Globals/Style/theme'
import { useMediaQuery } from '@Globals/useMediaQuery'

export const ProductSlider: FC = memo(({ children }) => {
  const isPhablet = useMediaQuery(`(min-width: ${appTheme.breakpoints.phablet})`)
  const isTablet = useMediaQuery(`(min-width: ${appTheme.breakpoints.tablet})`)
  const isDesktop = useMediaQuery(`(min-width: ${appTheme.breakpoints.desktop})`)
  const items = useMemo(() => filter(castArray(children)), [children])

  const [hideLeftArrow, setHideLeftArrow] = useState(true)

  let perPage = 2
  if (isPhablet) { perPage = 3 }
  if (isTablet) { perPage = 4 }
  if (isDesktop) { perPage = 5 }

  const itemWidth = `${Math.floor(90 / perPage)}%`

  // No reason to fire up the slider if we don't HAVE to.
  if (items.length <= perPage) {
    return (
      <StaticUpsellWrapper>
        {map(items, (item: ReactElement) => cloneElement(
          item,
          {
            style: {
              width: itemWidth,
            },
          },
        ))}
      </StaticUpsellWrapper>
    )
  }

  return (
    <StyledContainerSlider
      hideLeftArrow={hideLeftArrow}
      onMove={() => setHideLeftArrow(false)}
      options={{
        arrows: true,
        drag: true,
        breakpoints: undefined,
        fixedWidth: itemWidth,
        gap: appTheme.padding.phablet,
        pagination: false,
        perMove: perPage,
        perPage,
        width: '100%',
      }}
    >
      {map(items, (item: ReactElement) => cloneElement(
        <SplideSlide key={item.key}>{item}</SplideSlide>,
      ))}
    </StyledContainerSlider>
  )
})
